import { AUD_DESKTOP_AUD2776_CIAN_ASSISTANT_ENTRY_POINT } from 'shared/services/abUseExperiments/experiments';

import { IState } from '../../store';
import { abUseExperimentsSelector, isAbUseExperimentsActive } from '../abUseExperiments';

export function selectIsCianAssistantExperimentEnabled(state: IState) {
  const experiments = abUseExperimentsSelector(state);
  const bGroup = isAbUseExperimentsActive(experiments, AUD_DESKTOP_AUD2776_CIAN_ASSISTANT_ENTRY_POINT, 'B');
  const cGroup = isAbUseExperimentsActive(experiments, AUD_DESKTOP_AUD2776_CIAN_ASSISTANT_ENTRY_POINT, 'C');

  return bGroup || cGroup;
}
